import React, { useState } from 'react';

function SurveyStepThirtyTwo({ formData, onNext }) {
    const [wellbeingEncouragement, setWellbeingEncouragement] = useState(formData.wellbeingEncouragement || '');
    const [wellbeingComments, setWellbeingComments] = useState(formData.wellbeingComments || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!wellbeingEncouragement) {
            setError('Please select a rating.');
            return;
        }
        setError('');
        onNext({ wellbeingEncouragement, wellbeingComments });
    };

    const ratingOptions = ['N/A', ...Array.from({ length: 10 }, (_, i) => (i + 1).toString())];

    return (
        <div className="step-form">
            <h6 className="mb-4">Section 7: Leadership & Management</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <label className="form-label">
                How well does leadership encourage employees to prioritise well-being? <span className="text-danger">*</span>
            </label>

            <div className="d-flex flex-wrap gap-2 mb-4 justify-content-around">
                {ratingOptions.map((option) => (
                    <div key={option} className="form-check rating_btn">
                        <input
                            type="radio"
                            id={`wellbeing-encouragement-${option}`}
                            name="wellbeingEncouragement"
                            value={option}
                            checked={wellbeingEncouragement === option}
                            onChange={() => setWellbeingEncouragement(option)}
                        />
                        <label htmlFor={`wellbeing-encouragement-${option}`}>{option}</label>
                    </div>
                ))}
            </div>

            <div className="mb-3">
                <label className="form-label">Additional comments (optional):</label>
                <textarea
                    className="form-control"
                    rows="4"
                    value={wellbeingComments}
                    onChange={(e) => setWellbeingComments(e.target.value)}
                    placeholder="Share any additional thoughts here..."
                />
            </div>

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!wellbeingEncouragement}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default SurveyStepThirtyTwo;
